'use client';

import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  children,
  onClick,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  type = 'button',
  className = '',
  icon = null,
  ...props
}) => {
  const baseClasses =
    'font-medium rounded transition-colors duration-200 focus:outline-none inline-flex items-center justify-center';

  const variants = {
    primary: 'bg-[#01a7ff] text-white hover:bg-[#0095e6] disabled:bg-gray-400',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:bg-gray-100',
    outline:
      'border border-[#01a7ff] text-[#01a7ff] hover:bg-blue-50 disabled:border-gray-200 disabled:text-gray-400',
    ghost: 'bg-transparent border-none shadow-none',
  };

  const sizes = {
    small: 'px-3 py-1 text-sm',
    medium: 'px-4 py-2 text-base',
    large: 'px-6 py-3 text-lg',
  };

  const buttonClasses = `${baseClasses} ${variants[variant]} ${sizes[size]} ${disabled ? 'cursor-not-allowed' : ''} ${className}`;

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={buttonClasses} {...props}>
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline', 'ghost']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  icon: PropTypes.node,
};

export default Button;
